// extracted by mini-css-extract-plugin
export default {"title":"LcjItIHL_H"};